import type { SnapshotId } from '@ipfabric/utils';
import { isValidIp, isValidIpv6 } from 'utils/formValidation/validations';
import type { ApiRequestFunction } from 'utils/request/useApi';

/**
 * null = autodetect
 * '' = (empty)
 * nonempty string = other value
 */
export type Vrf = string | null;

export const fetchVrf = async (
  apiRequest: ApiRequestFunction,
  snapshotId: SnapshotId,
  ip: string,
): Promise<Vrf[]> => {
  const mask = isValidIpv6(ip) ? 128 : isValidIp(ip) ? 32 : null;
  const cidr = mask ? `${ip}/${mask}` : ip;

  if (!cidr) {
    return [null];
  }

  try {
    const vrfResponse = await apiRequest<Vrf[]>({
      url: `/graphs/path-lookup/vrfs?snapshot=${encodeURIComponent(snapshotId)}&cidr=${encodeURIComponent(cidr)}`,
      method: 'GET',
    });
    return vrfResponse;
  } catch {
    return [null];
  }
};
